import React, { FC } from 'react';
import { useSyncFilterValue } from '../../useSyncValue';
import { TControllerValue, TFilterSchemeString } from '../../models';
import { DATA_ELEM_ICON } from '../_Type@dateRange/consts';
import { Unit } from '@src/core/Unit';
import { Box } from '@src/atoms/Box';
import { Text } from '@src/atoms/Text';
import { isNotEmptyMessage } from '@src/utils/message';
import { TooltipNew } from '@src/atoms/TooltipNew';
import { Icon } from '@src/atoms/Icon';
import { Link } from '@src/atoms/Link';
import { Divider } from '@src/atoms/Divider';
import { ISwipeDialogFilterTypeProps } from '../models';
import { useOpenFilterByName } from '@src/hooks/useOpenFilterByName';

export const FilterSwipeDialogTypeString: FC<ISwipeDialogFilterTypeProps> = ({
  isLast,
  filter,
  controller,
  onOpen,
}) => {
  const { name, title, description, render } = filter as TFilterSchemeString;
  const filterValue = useSyncFilterValue({ controller, event: name }) as TControllerValue<string[]>;

  const handleClick = useOpenFilterByName(DATA_ELEM_ICON, onOpen, name);

  return (
    <>
      <Unit id="MobileFilterPropertyString" entityCtx={{ objectId: name, entityId: `filter` }}>
        <Box column gap={8} fullWidth>
          <Box fullWidth alignItems="center" justifyContent={'spaceBetween'} padding={16} onClick={handleClick}>
            <Box>
              <Text id="FilterPropertyName" color={'basicGreySemiDark'}>
                {render ? render(title) : title}
              </Text>
            </Box>
            <Box gap={16} alignItems="center">
              {isNotEmptyMessage(description) && (
                <TooltipNew
                  trigger="click"
                  content={
                    <Text id="FilterPropertyNameTooltip" size="caption">
                      <div dangerouslySetInnerHTML={{ __html: description }} />
                    </Text>
                  }
                >
                  <Icon name="circleOutlineQuestion" size="sm" data-elem={DATA_ELEM_ICON} />
                </TooltipNew>
              )}
              <Text id="valueText">{filterValue?.value}</Text>
              <Box>
                <Link id={'showOptions'}>
                  <Icon name="arrowRight" size="sm" />
                </Link>
              </Box>
            </Box>
          </Box>
        </Box>
      </Unit>
      {!isLast && (
        <Box marginLeft={16} marginRight={16}>
          <Divider />
        </Box>
      )}
    </>
  );
};
